import BillingDetails from './BillingDetails';

export default BillingDetails;
